import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent } from '../ui/dialog';
import { AlertCircle } from 'lucide-react';

export default function SemOperacoesModal({ open, onOpenChange, loteInfo, onClose }) {
  const handleClose = () => {
    onOpenChange(false);
    onClose && onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-3xl border-2 border-red-200">
        <div className="text-center p-4">
          <div className="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <AlertCircle className="h-12 w-12 text-red-600" />
          </div>

          <h2 className="text-xl font-bold text-red-700 mb-2">
            Sem Operações Atribuídas
          </h2>

          <p className="text-stone-600 mb-4">
            Não tem operações associadas a si neste lote.
            Por favor verifique com o seu responsável.
          </p>

          {loteInfo && (
            <div className="bg-stone-100 rounded-xl p-3 text-left mb-4">
              <div className="text-sm space-y-1">
                <p><span className="text-stone-500">OF:</span> <strong>{loteInfo.of_numero}</strong></p>
                <p><span className="text-stone-500">Lote:</span> <strong>{loteInfo.lote_codigo}</strong></p>
                <p><span className="text-stone-500">Artigo:</span> {loteInfo.artigo}</p>
                <p><span className="text-stone-500">Cliente:</span> {loteInfo.cliente}</p>
              </div>
            </div>
          )}

          <Button
            onClick={handleClose}
            className="w-full bg-red-600 hover:bg-red-700 text-white rounded-full h-12"
          >
            Entendido
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
